import ListenerHandler from './listener-handler';
import type { IReconnectable } from './types';

class NetworkManager implements IReconnectable {
  private readonly listenerHandler = new ListenerHandler();
  private isNetworkConnected: boolean = navigator.onLine;

  private reconnectCallback: () => void;
  private disconnectCallback: () => void;

  public listenConnectionChange(): void {
    this.listenerHandler.attachListener(window, 'online', this.onOnline.bind(this));
    this.listenerHandler.attachListener(window, 'offline', this.onOffline.bind(this));
  }

  public setReconnectCallback(callback: () => void): void {
    this.reconnectCallback = callback;
  }

  public setDisconnectCallback(callback: () => void): void {
    this.disconnectCallback = callback;
  }

  public detachListeners(): void {
    this.listenerHandler.detachListeners(window);
  }

  public isOnline(): boolean {
    return this.isNetworkConnected;
  }

  private readonly onOnline = (): void => {
    if (this.isNetworkConnected) {
      return;
    }
    this.isNetworkConnected = true;
    if (this.reconnectCallback) {
      this.reconnectCallback();
    }
  };

  private readonly onOffline = (): void => {
    if (!this.isNetworkConnected) {
      return;
    }
    this.disconnectCallback();
    this.isNetworkConnected = false;
  };
}

export default NetworkManager;
